import "./styles.scss";

import { forwardRef, useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { AnimatePresence, motion } from "framer-motion";
import classnames from "classnames";

import MobileBar from "components/MobileBar";
import BackMobile from "components/BackMobile";
import ScrollTopMobile from "components/ScrollTopMobile";

import useMergeRefs from "hooks/useMergeRefs";

const mainClass = "modal-mobile";

const ModalMobile = forwardRef(
  (
    {
      title,
      description,
      children,
      isOpen,
      isFlexColumn,
      hasMobileScrollTop = true,
      onClose,
    },
    ref,
  ) => {
    const innerRef = useRef(null);
    const mergedRef = useMergeRefs(ref, innerRef);

    useEffect(() => {
      const className = "modal-mobile-open";
      document.body.classList.toggle(className, isOpen);
      return () => document.body.classList.remove(className);
    }, [isOpen]);

    return createPortal(
      <AnimatePresence>
        {isOpen && (
          <motion.div
            ref={mergedRef}
            className={classnames(mainClass, {
              [`${mainClass}--flex-column`]: isFlexColumn,
            })}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ type: "tween", duration: 0.2 }}
          >
            <div className={`${mainClass}__inner`}>
              <MobileBar isStatic onWebsiteClick={onClose} />
              {onClose && (
                <div className={`${mainClass}__back`}>
                  <BackMobile onClick={onClose} />
                </div>
              )}
              {!!title && (
                <div className={`${mainClass}__header`}>
                  <h3>{title}</h3>
                  {!!description && <p>{description}</p>}
                </div>
              )}
              <div className={`${mainClass}__body`}>{children}</div>
              {hasMobileScrollTop && (
                <div className={`${mainClass}__scroll`}>
                  <ScrollTopMobile el={innerRef} />
                </div>
              )}
            </div>
          </motion.div>
        )}
      </AnimatePresence>,
      document.body,
    );
  },
);

export default ModalMobile;
